export const GET_MASTER = "/masters/"
export const ADD_COMPLAIN = "/ticket"
export const GET_TABLE = "/ticket?limit=10&"
export const GET_SINGLE_DATA = "/ticket/"

export const GET_CONTACT_TEXT = "/ticket/contact-text"
export const UPDATE_TICKET ="/ticket"

export const GET_DOWNLOAD_DATA = '/ticket'


